/* istanbul ignore file */

export const RANGE_OVERFLOW_COPY = 'Quantity must be less than or equal to';
export const QUANTITY_COPY = 'Quantity';
